import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActionData, ActionNote, ActionProductParticipation, ActionState, ActionStatus } from '../../types/action-center-types';
import { ActivatedRoute } from '@angular/router';
import { ActionCenterService } from '../../service/action-center.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { FullMonthYearPipe } from '../../../../core/pipes/full-month-year.pipe';
import { PageStateModel } from '../../types/page-state-model';

@Component({
    selector: 'app-action-details',
    templateUrl: './action-details.component.html',
    styleUrls: ['./action-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ActionDetailsComponent implements OnInit {

  recId: string = "";
  actionObj: ActionData | undefined = undefined;
  displayLoader: boolean = true;


  actionModel: ActionData | undefined;
  identifier: string = "";
  actionProduct: ActionProductParticipation | undefined;
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  recommendationStatusOptions = [ActionStatus.NoActionYet, ActionStatus.PitchedToCustomer, ActionStatus.CustomerAccepted, ActionStatus.EnteredInESS, ActionStatus.ActionInProgress, ActionStatus.Completed];
  grayHex = '#E0E0E0'
  orangeHex: string = '#F17A22';
  greenHex: string = '#39B54A';

  tvditems = [
    {
      icon: 'assets/tvd_icon_image_assets.png',
      text: 'Assets',
      cashAmt: '$1,234',
      unitAmt: '1 Program'
    },
    {
      icon: 'assets/tvd_icon_image_waste_blue.png',
      text: 'Plastic Waste',
      cashAmt: '$1,234',
      unitAmt: '111lbs Reduced'
    },
    {
      icon: 'assets/tvd_icon_image_waste_blue.png',
      text: 'Cardboard Waste',
      cashAmt: '$1,234',
      unitAmt: '1b Reduced'
    },
    {
      icon: 'assets/tvd_icon_image_productivity_blue.png',
      text: 'Productivity',
      cashAmt: '$1,234',
      unitAmt: '111hrs Gained'
    },
    {
      icon: 'assets/tvd_icon_image_energy_blue.png',
      text: 'Energy',
      cashAmt: '$1,234',
      unitAmt: '1,111 Therms'
    },
    {
      icon: 'assets/tvd_icon_image_water_blue.png',
      text: 'Water',
      cashAmt: '$1,234',
      unitAmt: '11,111 Gallons'
    },
    {
      icon: 'assets/tvd_icon_image_water_blue.png',
      text: 'Greenhouse Gases',
      cashAmt: '$1,234',
      unitAmt: '11mt of CO2'
    },
    {
      icon: 'assets/tvd_icon_image_safety_blue.png',
      text: 'Employee Safety',
      cashAmt: '$1,234',
      unitAmt: '111lbs Less Lifted'
    }
  ];
  currDate: Date = new Date(Date.now());
  currMonth: string = this.months[this.currDate.getMonth()];
  imageSource: string = 'assets/down-chevron.svg';
  showAllItems: boolean = false;
  showAllMonths: boolean = false;
  hideLoadMore: boolean = false;

  noteBoxContents: string = ""
  noteBoxDateMap: Map<string, ActionNote[]> = new Map<string, ActionNote[]>();

  private noteBoxDateMapBehaviorSubject: BehaviorSubject<any> = new BehaviorSubject<string[]>(Array.from(this.noteBoxDateMap.keys()));
  noteBoxKeysObservable = this.noteBoxDateMapBehaviorSubject.asObservable();

  previousPage: ActionState = ActionState.Recommended;

  constructor(
    private route: ActivatedRoute,
    private acService: ActionCenterService,
    private router: Router,
  ){}

  ngOnInit(): void {
    // Get the id from the URL
    this.recId = this.route.snapshot.params['recId'];

    this.identifier = this.route.snapshot.params['recId'];

    let currPage: PageStateModel = this.acService.pageData.value;
    this.actionModel = currPage?.actions.find(action => action.recId == this.identifier);

    this.actionProduct = {
      productName: this.actionModel?.productName || "",
      productSKU: this.actionModel?.sku || "",
      solution: this.actionModel?.solution || "",
    };

    this.actionModel?.actionNotes.forEach(note => this.addActionNoteToDateGroup(note));

    this.previousPage = this.acService.pageState.value;
  }

  ngOnDestroy(): void {
    // if (this.actionModel?.actionStatus == "Completed") {
    //   //saving user moving to "completed" state
    //   this.acService.completeAction(this.actionId);
    // }
  }

  onClick() {
    this.router.navigate(['./solution-participation-details']);
  }

  //To toggle style of the chevron svgs
  getImageClass(): string {
    return this.imageSource === 'assets/down-chevron.svg' ? 'imageStyleA' : 'imageStyleB';
  }
  toggleChevron() {
    this.showAllItems = !this.showAllItems;
    if (this.imageSource === 'assets/down-chevron.svg') {
      this.imageSource = 'assets/right-chevron.svg';
    } else {
      this.imageSource = 'assets/down-chevron.svg';
    }
  }

  setDates(): void {
    // if (this.actionModel?.recState.recommendationStatus == 'Action in Progress') {
    //   // this.acService.startAction(this.actionModel);
    //   // this.actionModel.endDate = undefined;
    // }
    // else if (this.actionModel?..recState.recommendationStatus == 'Completed') {
    //   // this.acService.endAction(this.actionModel);
    // }
    // else {
    //   // this.actionModel!.startDate = undefined;
    //   // this.actionModel!.endDate = undefined;
    // }
  }

  addActionNote(): void {
    if (this.noteBoxContents !== "") {
      let note: ActionNote = {
        noteDate: (new Date(Date.now())).toLocaleString(),
        noteContents: this.noteBoxContents
      };

      // this.acService.addNoteToActionItem(note, this.actionId);
      this.addActionNoteToDateGroup(note);

      this.noteBoxContents = "";
    }
  }

  cancel(): void {
    if (this.noteBoxContents !== "") {
      this.noteBoxContents = "";
    }
  }

  private addActionNoteToDateGroup(note: ActionNote): void {

    let key = this.createNoteGroupKey(new Date(note.noteDate));
    if (!this.noteBoxDateMap.has(key)) {
      this.noteBoxDateMap.set(key, []);
      this.noteBoxDateMapBehaviorSubject.next(Array.from(this.noteBoxDateMap.keys()));
    }
    this.noteBoxDateMap.get(key)?.push(note);

  }

  private createNoteGroupKey(date: Date): string {
    let pipe = new FullMonthYearPipe();;
    return pipe.transform(date);
  }

  convertDate(date: string): Date {
    return new Date(date)
  }

}
